export var TransactionErrorType;
(function (TransactionErrorType) {
    TransactionErrorType["NotConfirmed"] = "not-confirmed";
    TransactionErrorType["Cancelled"] = "cancelled";
    TransactionErrorType["NodeBehind"] = "node-behind";
    TransactionErrorType["SignatureRequestDenied"] = "signature-request-denied";
    TransactionErrorType["InsufficientSOL"] = "insufficient-sol";
})(TransactionErrorType || (TransactionErrorType = {}));
//# sourceMappingURL=types.js.map